import image1 from "../../../Assets/cashew/cashewkernel2.webp";
import image2 from "../../../Assets/Cocoa/cocoa seed2.jpeg";
import image3 from "../../../Assets/Charcoal/charcoal2.jpg";
import image4 from "../../../Assets/Seasame/White Sesame seed.jpeg";
import image6 from "../../../Assets/Other-product/ginger.jpeg";

const data = [
  {
    id: 1,
    name: "Cashew Nuts",
    Image: image1,
    link: "/cashew",
  },
  {
    id: 2,
    name: "Cocoa Seeds",
    Image: image2,
    link: "/cocoa",
  },
  {
    id: 3,
    name: "Charcoal",
    Image: image3,
    link: "/charcoal",
  },
  {
    id: 4,
    name: "Seasame",
    Image: image4,
    link: "/seasame",
  },
  {
    id: 5,
    name: "Shea Butter",
    Image:
      "https://149520306.v2.pressablecdn.com/wp-content/uploads/2019/06/Shea-butter.jpeg",
    link: "/sheaButter",
  },
  {
    id: 6,
    name: "Ginger",
    Image: image6,
    link: "/ginger",
  },
];

export default data;
